var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 46.5,
    r: 43.5,
    stroke: "black",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.8588 55.0908C63.7325 55.0908 60.7079 54.5825 57.8867 53.6675C56.9971 53.3625 56.0058 53.5913 55.3196 54.2775L51.3292 59.2846C44.1362 55.8533 37.4008 49.3721 33.8171 41.925L38.7733 37.7058C39.4596 36.9942 39.6629 36.0029 39.3833 35.1133C38.4429 32.2921 37.96 29.2675 37.96 26.1413C37.96 24.7688 36.8163 23.625 35.4438 23.625H26.6496C25.2771 23.625 23.625 24.235 23.625 26.1413C23.625 49.7533 43.2721 69.375 66.8588 69.375C68.6633 69.375 69.375 67.7738 69.375 66.3758V57.6071C69.375 56.2346 68.2313 55.0908 66.8588 55.0908Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.3354ddd4195d622be76e7a667d13fa9b.svg";
export { ForwardRef as ReactComponent };